import * as React from "react";
import * as videojs from "video.js";
import "videojs-contrib-hls.js";

interface Props {
  poster: string;
  url: string;
  className?: string;
}

export class VideoPlayer extends React.Component<Props, {}> {
  private player: any;
  private video: HTMLVideoElement;

  componentDidMount() {
    this.player = (videojs as any)(this.video, {});
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  render(): JSX.Element {
    return (
      <video
        ref={ref => this.video = ref}
        className={`video-js vjs-default-skin ${this.props.className}`}
        controls
        preload="auto"
        poster={this.props.poster}
      >
        <source src={this.props.url} type="application/x-mpegURL" />
      </video>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/video-player/index.tsx